import * as React from 'react';
import { IFilterBarContext } from './';

export const FilterBarContext = React.createContext<IFilterBarContext>({} as IFilterBarContext);

export const useFilterBarContext = () => React.useContext(FilterBarContext);
